<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0121 12c0 1.39-.252 2.721-.709 3.963M3.291 7.582A11.953 11.953 0 003 12c0 1.39.252 2.721.709 3.963m0 0a8.959 8.959 0 01-1.292-.928m1.292.928c.375.414.851.764 1.416 1.028M5.375 15.482c0 0 0 .001 0 0z"
    />
  </svg>
</template>
